import SelectAsync from '../components/Form/SelectAsync'

export default {
    props: {
        value: [ String, Number, Array, Object ],
        hasError: Boolean,
        searchFunction: Function
    },
    methods: {
        search(search) {
            return this.searchFunction ? this.searchFunction(search) : this.defaultSearch(search)
        }
    },
    components: {
        SelectAsync
    },
    computed:{
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    }
}
